import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useMe } from 'src/graphql/hooks'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const UserAccountControl = ({ display }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const { me, loading, isLoggedIn } = useMe()

   return (
      <View display={display}>
         {!loading && !isLoggedIn && (
            <NavLink to="/login">
               <Text
                  color={theme.tmpMainMenuTextColor}
                  size="1.5[a-d] 2[e-f]"
                  weight="medium">
                  Sign in
               </Text>
            </NavLink>
         )}
         {isLoggedIn && (
            <NavLink to="/profile">
               <View display="flex" alignItems="center">
                  <Text
                     color={theme.tmpMainMenuTextColor}
                     size="1.5[a-d] 2[e-f]"
                     weight="medium">
                     {me.firstName}
                  </Text>
               </View>
            </NavLink>
         )}
      </View>
   )
}

UserAccountControl.propTypes = {
   display: PropTypes.string
}

UserAccountControl.defaultProps = {
   display: 'none[a-c] block[d-f]'
}

export default React.memo(UserAccountControl)
